import { formatDate } from '../../utils/Dates';
import defaultBenefitImage from '../../../assets/images/defaultLocalBenefit.svg?url';
import { Benefit } from './CardBenefitPartner.types';

export function getBenefitLink({
  isLocalContent,
  departmentSlug,
  slug,
  itemSlug,
  abTestExperimentSlug,
}: {
  isLocalContent?: boolean;
  departmentSlug?: string;
  slug?: string;
  itemSlug?: string;
  abTestExperimentSlug?: string | null;
}) {
  const local =
    isLocalContent && departmentSlug && slug
      ? `/her-finner-du-naf/lokalavdelinger/${departmentSlug}/fordeler/${slug}`
      : null;
  const global = `/medlemskap/medlemsfordeler/${itemSlug}`;
  const base = local || global;
  return abTestExperimentSlug ? `/${abTestExperimentSlug}` : base;
}

// A campaign swaps in its own title/ingress/discount badge/banner text while it's running.
export function getDisplayContent(benefit: Benefit) {
  const { title, name, listIngress, discountBadge, campaignDetails } = benefit;
  const hasActiveCampaign = !!(campaignDetails?.endDate && new Date(campaignDetails.endDate) > new Date());

  return {
    displayTitle: (hasActiveCampaign && campaignDetails?.title) || title || name,
    displayIngress: (hasActiveCampaign && campaignDetails?.ingress) || listIngress,
    displayDiscountBadge: (hasActiveCampaign && campaignDetails?.discountBadge) || discountBadge,
    campaignText: hasActiveCampaign ? `Varer til ${formatDate(campaignDetails.endDate)}` : undefined,
  };
}

export function getDisplayImage({
  benefit,
  cldImageUrl,
  img,
}: {
  benefit: Benefit;
  cldImageUrl?: string;
  img?: { src: string; alt: string };
}) {
  const { isLocalContent, localBenefitImage, image } = benefit;
  const localImage =
    localBenefitImage?.source === 'NafIllustration' ? defaultBenefitImage : localBenefitImage?.url || '';

  return {
    src: isLocalContent ? localImage || image?.srcSet?.jpgLarge || '' : cldImageUrl || img?.src || defaultBenefitImage,
    alt: isLocalContent ? localBenefitImage?.caption || '' : image?.altText || img?.alt || '',
    loading: 'lazy' as const,
  };
}

export function getDisplayLogo(partner: Benefit['partner']) {
  if (!partner?.logo) return undefined;
  return {
    src: partner.logo.srcSet.jpgLarge,
    alt: partner.partnerName ? `${partner.partnerName} logo` : 'Partnerlogo',
  };
}
